export type DwellerD = {
    id: string;
    name: string;
    phylum: string;
    size: string;
    frequency: string;
    num: string;
    abilities: string;
    resistances: string;
    description: string;
};

export const Phylums: string[] = ["Beast", "Deep One", "Demon", "Fey", "Humanoid", "Mythic", "Ooze", "Undead"];

export const DWELLERS_INFO: DwellerD[] = [
    {
        id: "arkan",
        frequency: "rare",
        num: "1-2",
        name: "Arkan",
        phylum: "Fey",
        size: "medium",
        description:
            "If you be the paranoid type, cease reading now - for the dreaded arkan is known for camouflaging itself to resemble a TREE while it waits to ambush you. A tree!! Those are literally everywhere! It's enough to drive you mad, thinking that every single oak, maple or pine might actually be a ghoulish, axe-weilding arkan waiting to behead you. What's next, demons disguised as the very AIR ITSEL-- oh, wait, we have those. See \"WISP,\" page 232.",
        resistances: "vulnerable to fire, resistant to pierce",
        abilities: "camouflage",
    },
    {
        id: "bananach",
        frequency: "legendary",
        num: "1",
        name: "Bananach",
        phylum: "Demon",
        size: "large",
        description:
            "When I first heard tell of the bananach I thought, okay, we finally have a FUN Dweller to learn about. Mayhaps a piece of tropical fruit has been hexed by some jaded warlock who needed some a droll diversion after a wearying day of research. Adventurer, prepare to be disappointed. The bananach is in fact a floating, dessicated corpse with the skull of a man and the body of some withered amphibious abomination. It's a nightmare creature that will freeze your blood with demonic magic and dance on your ruined corpse, waving its bony limbs about and bobbing up and down, not unlike a jaunty banana might. Oh! That's probably where the name comes from.",
        resistances: "vulnerable to bludgeon, resistant to arcane",
        abilities: "inflicts fear",
    },
    {
        id: "blackpudding",
        frequency: "epic",
        num: "1",
        name: "Black Pudding",
        phylum: "Ooze",
        size: "medium",
        description:
            "WOE UNTO YE FOOLISH ADVENTURERS THAT DO NOT HEED THE VAST AND MYRIAD DIFFERENCES BOTH BIOLOGICAL AND BEHAVIORAL BETWEEN THE DREADED BLACK PUDDING AND EQUALLY DEADLY BROWN PUDDING!! IN THIS 300 PAGE TOME I SHALL ENUMERATE THE THOUSANDS OF YEARS OF RESEARCH WHICH HAS PROVEN BEYOND A SHADOW OF I jest, i jest. They are nearly identical. This one hates cold. The other one hates fire.",
        resistances: "vulnerable to cold, resistant to bludgeon",
        abilities: "explodes on death",
    },
    {
        id: "brownpudding",
        frequency: "rare",
        num: "1",
        name: "Brown Pudding",
        phylum: "Ooze",
        size: "medium",
        description:
            "O! I did note one substantial difference between the black pudding and this, the brown pudding. The BLACK pudding resembles a PUDDLE OF MUD, and the BROWN pudding resembles a PUDDLE OF FECES.",
        resistances: "vulnerable to fire, resistant to bludgeon",
        abilities: "explodes on death",
    },
    {
        id: "brownie",
        frequency: "rare",
        num: "1-4",
        name: "Brownie",
        phylum: "Fey",
        size: "medium",
        description:
            "O, do I despise brownies. This compendium is full, nay, overflowing with all manner of disgusting and terrible beasts, but none is more despicable than these little fiends. They lie in wait in the LITERAL BUSHES until you pass close enough for them to stun you with magic, then they stack curse after curse upon you (or, occasionally just stab you with their tiny knives scores of times) until you perish. They are the weeping pustules on the hind end of the world. They're also unbearably CUTE which makes it all even WORSE.",
        resistances: "vulnerable to blade",
        abilities: "inflicts stun",
    },
    {
        id: "bubbleeyes",
        frequency: "epic",
        num: "1",
        name: "Bubble Eyes",
        phylum: "Fey",
        size: "small",
        description:
            "If you're thinking this thing looks like a tanner's bear trap sprouted eye stalks, you're pretty much spot on. The jaws of this fearsome beast are not its only danger; it also has the obnoxiously deadly habit of exploding into a crackling fulmination of lightning bolts upon its death. If that weren't enough, it seems like one of its freakish eyes is always staring right at your nethers. Keep your eye stalks to yourself, fiend!",
        resistances: "resistant to electric",
        abilities: "inflicts confusion",
    },
    {
        id: "cockatrice",
        frequency: "epic",
        num: "1-3",
        name: "Cockatrice",
        phylum: "Mythic",
        size: "small",
        description:
            "The cockatrice is a prime example of what happens when wizards get a little too into breeding boutique magical animals. Sure, we've all considered employing a wizard to conjure up a managably-sized dragon that would travel at our side, roasting our foes during the day and roasting our meats in the evening. But then that same wizard, thick as a Tewksbury mustard, places a rooster's head atop that tiny dragon's body, and suddenly it no longer breathes flame at foes, but instead fires its newly lethal gaze at YOU! And the meat skewers, you ask? INEDIBLY RAW.",
        resistances: "resistant to necrotic",
        abilities: "necrotic gaze",
    },
    {
        id: "collector",
        frequency: "rare",
        num: "1",
        name: "Collector",
        phylum: "Demon",
        size: "small",
        description:
            "I have never been the sort of wizard who goes in for mercenary work. My adventuring days were about knowledge and exploration, first and foremost. But when I see a Collector? I kill it quick and make some FILTHY LUCRE, that's what! But beware, these diminuitive demons wield powerful magic - if you're not careful it will be YOUR corpse being looted for coin. They may even steal it from you in the very midst of battle. That's why I never keep my coin purse in my back pocket. That's a tourist mistake.",
        resistances: "vulnerable to arcane",
        abilities: "steals gold",
    },
    {
        id: "crawler",
        frequency: "rare",
        num: "1-3",
        name: "Crawler",
        phylum: "Deep One",
        size: "medium",
        description:
            'It has long peeved me that this nightmarish creature is referred to as a "Crawler." Yes, it does crawl of course, who doesn\'t? But its most prominent trait is OBVIOUSLY BURROWING. Through the soil, the sand, bare rock, and of course the deceased bodies of its victims, where it will lie in wait for another roving band of adventurers to wander by and mistake its undulations for the writhing of an injured compatriot. My point is: why not call it a BURROWER?',
        resistances: "vulnerable to pierce, resistant to blade",
        abilities: "inflicts poison",
    },
    {
        id: "deadknight",
        frequency: "epic",
        num: "1",
        name: "Dead Knight",
        phylum: "Undead",
        size: "medium",
        description:
            "I know what you're thinking - how formidable a knight could this be if he's already been slain once? Well, that is a textbook fallacy which you shall learn at your own peril! He's already been slain once, now he has nothing to lose! Think on that! Actually, don't get too caught up in the motivation of this wraith. Just focusing on killing it, and avoiding its fell blade, which you just KNOW is cursed or something.",
        resistances: "vulnerable to divine, immune to poison",
        abilities: "inflicts bleeding",
    },
    {
        id: "devilbones",
        frequency: "epic",
        num: "1-4",
        name: "Devil Bones",
        phylum: "Undead",
        size: "large",
        description:
            "I shall admit even I am still trying to wrap my head around devil bones. Is it the skeleton of a devil? Meaning a devil died but then decomposed like an ordinary creature and was later reanimated? By what, a different also-regular devil? Why? Demons are literal hellspawn! Just make a new one! Alternatively, is this the devil bones' natural state, bones from the start? Why go to the trouble of making a demon held together by nothing but magic and, what, good balance?? At least put a little skin or sinew on there, keep things together! At any rate, battle this clickety-clacking enigma just the way you'd expect - with magic of any kind. And if all else fails, just give it a good whack with a blunt object and send those bones flying.",
        resistances: "vulnerable to arcane, resistant to poison",
        abilities: "regenerates",
    },
    {
        id: "ditchwitch",
        frequency: "rare",
        num: "1-2",
        name: "Ditch Witch",
        phylum: "Humanoid",
        size: "medium",
        description:
            "There are several pieces of advice I could give you on surviving an encounter with a ditch witch: avoid her ranged attacks, beware her cursed bone kris, attack her with fire but not cold. But the biggest one is this: do NOT under ANY CIRCUMSTANCES call her a \"ditch witch\" to her face. Just keep it to yourself! Yes, yes, of course they are members of the foul Grep'lan Wiccan Order of High Sorceresses and Enchantresses Who Bask in the All-Knowing Light of Kordashim The Moonseer. But who has the time? You get halfway through saying that and there's a bone kris through your eye.",
        resistances: "resistant to cold",
        abilities: "ranged magic, inflicts slow",
    },
    {
        id: "dramock",
        frequency: "legendary",
        num: "1",
        name: "Dramock",
        phylum: "Demon",
        size: "large",
        description:
            "Here's a little tip: next time you go to a temple, or a cathedral or some other holy place, look around for paintings of demons. They're usually the ones surrounded by flames or charred bodies or something. Log them away, draw a little sketch if you want, and then when you're out in the woods looking for treasure chests or whatever, and you see one of these rising up out of a cavern, you check your sketch really quick to make sure, and then you run like hell. Simple as that!",
        resistances: "resistant to fire & electric",
        abilities: "inflicts fear, burning",
    },
    {
        id: "dwarv",
        frequency: "uncommon",
        num: "1-3",
        name: "Dwarv",
        phylum: "Humanoid",
        size: "medium",
        description:
            "Dwarvs have a reputation for honor and valor and I cannot for the life of me ascertain the reason. Every Dwarv I have known (or killed!) spent most of their time howling oaths to some long-dead mountain god whilst chopping anything in their path to splinters. And the smithing! Always prattling on about how they smithed this and their father smithed that and their grandfather mined some ore or other and then smithed it. No thank you. They are blunt instruments covered in hair and iron and I DO NOT have the patience for it, I AM SORRY.",
        resistances: "high defense",
        abilities: "",
    },
    {
        id: "feywing",
        frequency: "rare",
        num: "1-4",
        name: "Fey Wing",
        phylum: "Fey",
        size: "small",
        description:
            "Do not be taken in by the diminutive stature and sportive nature of the fey wing. They are known to put on a playful, harmless act at first, so that a battle-hardened warrior might drop their guard and engage in some frivolity with them. This is the very moment they strike, just when you have caught a leathern sphere you foolishly believed was tossed to you in good faith. A cruel trick, especially on adventurers, a profession that frequently finds itself without adequate leisure time!",
        resistances: "resistant to arcane",
        abilities: "teleport",
    },
    {
        id: "fomoian",
        frequency: "rare",
        num: "1",
        name: "Fomoian",
        phylum: "Demon",
        size: "large",
        description:
            "The fomoian is a strange, solitary creature, seemingly content to roam a dungeon alone, whipping at any living thing that comes near with startling accuracy. Yet there are whispers that if you follow behind a fomoian, careful to remain out of sight, you will hear it groan mournfully as a complaint against this endless drudgery. Its plaintive wails speak of a deep longing for invitations to social gatherings, and the merriment that attends such functions. Indeed, it will inflict upon you the rage reserved for its deepest fear: that of missing out.",
        resistances: "resistant to electric, fire, cold",
        abilities: "drains spirit",
    },
    {
        id: "gainsgob",
        frequency: "epic",
        num: "1",
        name: "Gains Goblin",
        phylum: "Humanoid",
        size: "medium",
        description:
            "Previous printings of this tome had an eloquent, helpful and, if I may say, frequently droll description of the venerable gains goblin, a beast I discovered many years ago during my travels in the mountains to the West. But I was recently informed that the creature was actually discovered several WEEKS earlier by some fly-by-night adventurer with the unfortunate moniker of \"Dorknuts,\" so I was forced to amend this entry to give this person credit. Well, felicitations, Dorknuts! You happened to be in the right place at the right time, just steps ahead of me on some mountain path, and now you've forced me to discard a perfectly useful passage so that all may know your ridiculous name. In any case, the gains goblin, as Dorknuts is only too keen to remind you, is a gnarled, ugly creature who travels alone and is motivated only by its appetite for gold, gems, jewels and the occasional high-value musical instrument. Surprisingly, the enormous sack they carry with them is not filled with loot but rather cheap trinkets used as a lure or distraction. No, the gains goblin literally EATS treasure, and digests it so completely that even cleaving the beast in two will give you no hope of reclaiming its meal. Which really is my only consolation - I hold out hope that somewhere out there, years ago, some gains goblin probably ate Dorknuts' lute or something.",
        resistances: "vulnerable to poison",
        abilities: "destroys gold & items",
    },
    {
        id: "gargoyle",
        frequency: "rare",
        num: "1",
        name: "Gargoyle",
        phylum: "Mythic",
        size: "large",
        description:
            'Know you any devout pious types who spend their days all "My heart knows only the will of the gods!" or "Simply cleanse yourself in the glow of the Loving Light!" or "Know Drachnor, Know Peace!" but then you see them out at a tavern later stabbing a bar gnome or something? That\'s gargoyles. By day they guard the grand cathedrals dotting these lands, then they take to the caverns and dungeons to throw a granite fist through your face at the slightest provocation. Terrible.',
        resistances: "resistant to all physical attacks",
        abilities: "slow, high damage",
    },
    {
        id: "gem_lizard",
        frequency: "legendary",
        num: "1",
        name: "Gem Lizard",
        phylum: "Beast",
        size: "small",
        description:
            'Novice explorers may assume that a creature known as a "gem lizard" is an easy target for a hefty reward, but that line of thinking has been the beginning and end of many adventuring careers. These hardy beasts may be slow, but their skin is nearly impenetrable, their bites can easily sever an arm, and the gems that grow upon their backs render them impervious to most magics. And yes, the gems are pretty valuable. But more valuable than your limbs? That\'s up to you.',
        resistances: "resistant to divine, arcane, electric",
        abilities: "powerful bite",
    },
    {
        id: "ghast",
        frequency: "rare",
        num: "1-3",
        name: "Ghast",
        phylum: "Undead",
        size: "medium",
        description:
            "In this magical world you must pick a side as it pertains to reanimated corpses: Ghast or Zombie? Are you horrified at the thought of a rotting corpse huffing its rancid breath on your neck as it prepares to devour you? Or are you more frightened by the notion of a berobed, haunted soul, casting its necrotic curses from afar, then silently advancing upon you to steal your life force while it stares at you with its empty, unfeeling eye sockets? Me, I'm a ghast person ALL THE WAY. Zombies are loud, slow, oafish. Give me a eerily floating dessicated carcass ANY DAY. Zombies are for concupiscent youths and meathead axe-wielders with delusions of grandeur.",
        resistances: "immune to necrotic, vulnerable to divine",
        abilities: "necrotic aura",
    },
    {
        id: "giantbats",
        frequency: "uncommon",
        num: "1-6",
        name: "Giant Bats",
        phylum: "Beast",
        size: "small",
        description:
            "The veins of magical ores running through the mountainside caves have given rise to these unnatural and ravenous beasts, which is a bummer, because regular bats were already pretty creepy to begin with. Their serrated teeth ensure their victims produce ample blood flow, and their ability to sense incoming projectiles makes fighting them at long range no easy task. You may, however, gain the upper hand them with the same tool used to vanquish any darkness: FIRE.",
        resistances: "resistant to poison, vulnerable to fire",
        abilities: "high dodge",
    },
    {
        id: "giantrat",
        frequency: "uncommon",
        num: "1-6",
        name: "Giant Rat",
        phylum: "Beast",
        size: "small",
        description:
            'O, so you espied a big rat and you run straight to this compendium to see if it is some sort of mythical creature? Try leaving the tavern alley and doing some actual adventuring before rushing to the literature. Mayhaps it is just a very large rat!! And what if it IS indeed an unnatural beast, what then? Is this the work of arcane mischief? Who knows. Listen, this is not ballistic science. I\'m just telling you what you can likely surmise yourself - the "giant rat" is, in EVEN MORE plain words, a big-arse rat. Stab it until it dies.',
        resistances: "vulnerable to electric",
        abilities: "",
    },
    {
        id: "giantsnake",
        frequency: "uncommon",
        num: "1-3",
        name: "Giant Snake",
        phylum: "Beast",
        size: "small",
        description:
            "There are a great many deadly mistakes to make when dealing with the great asps of Ell'esstris; chief among them is underestimating their intelligence. Their complex language, indiscernible to mammalian ears, can communicate detailed information amongst their own, such as your location, the weapons you carry, and weak points in your armor. Oh, and their venom can kill you in like 3 seconds. So don't overthink the talking-snake thing. Focus on killing it without getting bitten.",
        resistances: "resistant to poison",
        abilities: "inflicts poison",
    },
    {
        id: "giantspider",
        frequency: "uncommon",
        num: "1-5",
        name: "Giant Spider",
        phylum: "Beast",
        size: "medium",
        description:
            "Look, adventurer - if the phrase \"giant spider\" doesn't tell you all you need to know, I'm not really sure what else to say. Fangs that pierce armor, webs that are invisible in the dark, and venom that digests you from the inside out. Standard nightmare stuff. Stay far, far away. Still interested? Not my problem. Find a tome written by some masochist.",
        resistances: "resistant to poison",
        abilities: "inflicts poison, stun",
    },
    {
        id: "giantwasp",
        frequency: "rare",
        num: "1-8",
        name: "Giant Wasp",
        phylum: "Beast",
        size: "small",
        description:
            "Legends tell that the fabled Reduvian Orcs would use giant wasp stingers to torture their enemies. That checks out, because the Reduvian orcs were, famously, enormous assholes. True or not, \"torture\" is really the only way to describe the sensation of the venom of these hideous monsters - a searing, blinding, nauseating pain that overtakes every sense and renders the victim unable to control his weapon, shield, movement, or, as you'd no doubt expect, bowels. Too much lore, or TML, as the youths are saying these days? Perhaps. But if it urges you to keep your distance, then my work here is done. You're welcome.",
        resistances: "resistant to poison",
        abilities: "inflicts poison, high dodge",
    },
    {
        id: "goblin",
        frequency: "rare",
        num: "1-5",
        name: "Goblin",
        phylum: "Humanoid",
        size: "medium",
        description:
            "You know that one youth you attended studiorum with who always talked about the coolest plays, wore robes featuring that summer's hottest lutenist, and bragged about all the maids he sarded when he was captain of the shinty team? Then you found out that he got all that stuff from his older brother, and had never seen the plays, couldn't tell a lute from a timbrel, and had never once even played shinty? That is goblins in a nutshell. Every last weapon, scrap of armor, banner and tunic is just pilfered from the adventurers they've looted and murdered. They keep it in enormous underground armories (a charitable way of referring to a pile of stuff in a cave) and outfit themselves with whatever they think makes them look like they know what they're doing. They have no culture, no strategy, and no ethos. They do still have my mothersarding hat, though!!",
        resistances: "vulnerable to necrotic",
        abilities: "ranged attacks",
    },
    {
        id: "greiger",
        frequency: "legendary",
        num: "1",
        name: "Greiger",
        phylum: "Deep One",
        size: "medium",
        description:
            "Sweet merciful Thragos on a dead horse. What IS this thing? Listen, I'm usually pretty up to date on the Dwellers in these lands. Something of an expert you might say. But, gods, I have never once seen this monstrosity. I have no clue what it is. It's an abomination, that's all I can tell you. Run. Just run.",
        resistances: "vulnerable to cold, resistant to blade",
        abilities: "inflicts freezing, confusion",
    },
    {
        id: "harpy",
        frequency: "epic",
        num: "1-3",
        name: "Harpy",
        phylum: "Mythic",
        size: "medium",
        description:
            'I know a handful of men, all of them idiots, who will occasionaly refer to their spouse, or EX-spouse, or sometimes PROGENITRESS-IN-LAW, as a "harpy." O TRULY?? Your wife has wings instead of arms? She is a feathered, emaciated personification of the WIND ITSELF? This woman you married hatches brilliant orange eggs high on a cliffside and feeds her young a steady regurgitated diet of half-digested snakes and the eyeballs of warriors who did not hear her feathery wingbeats in time? YES I THOUGHT NOT!',
        resistances: "resistant to cold",
        abilities: "drains agility",
    },
    {
        id: "hobgob",
        frequency: "uncommon",
        num: "1-3",
        name: "Hob Gob",
        phylum: "Humanoid",
        size: "medium",
        description:
            "Even the most formidable Dwellers in this humble compendium are less intimidating when you know which meat pie you're biting into, as the saying goes. Not so with the Hob Gobs, who are perhaps the most terrifying because they are absolute batsquirt crazy. There is nothing predictable about them besides their bloodlust and complete lack of fear. They have nothing to lose, which means you have everything to lose. Avoid their enormous hammerblades (a not great sign on its own), and don't even try to get through their armor - a stout magical attack is your best hope.",
        resistances: "vulnerable to arcane, resistant to pierce",
        abilities: "high defense",
    },
    {
        id: "jelcube",
        frequency: "epic",
        num: "1",
        name: "Jel Cube",
        phylum: "Ooze",
        size: "large",
        description:
            "Now here is a quandary. I am generally of the mind that all creatures magical and otherwise have some sort of REASON for existing. Ordinary flora and fauna have found and adapted to their environs based on their predators and prey; magical and mythical figures exist from either the folly of mortals, the sorcery of the wicked, or to fill voids of power, magic or divinity. So, assuming all that, what in the nine hells is the jel cube doing here? It's a cube (!) of glue (!!) but also... vindictive somehow (!!?). Mayhaps everything I know is wrong. It's enough to make me want to turn in my staff and call it a day. ",
        resistances: "resistant to pierce",
        abilities: "inflicts held, poison",
    },
    {
        id: "kobold",
        frequency: "uncommon",
        num: "1-4",
        name: "Kobold",
        phylum: "Humanoid",
        size: "small",
        description:
            "Everyone likes to say that dogs are man's best friend, but you give them a dirk or a tiny mace and suddenly they're man's most execrable stickup artist. Annoyingly, whatever magicks have conspired to give these little mutants opposable thumbs and upright gaits neglected to remove their lolling tongues and disgusting hound breath. And even if you disarm them, you're only increasing the likelihood that they clamp their jagged teeth into your behind and hang there, growling, like some sort of lewd children's etching. This is why I am firmly a cat person.",
        resistances: "vulnerable to necrotic",
        abilities: "calls for help",
    },
    {
        id: "losttoad",
        frequency: "legendary",
        num: "1",
        name: "Lost Toad",
        phylum: "Beast",
        size: "small",
        description:
            'Compared to your garden variety toad, this colorful lot appears to be significantly more intelligent and, frankly, chill than their warty counterparts. It is believed they are on the run from a certain evil king in the west called Gremplin, and the dungeons that dot our strange land seemingly make a good refuge. They are friendly, and have been known to help an adventurer out, provided the adventurer is transmitting what can only be called "positive vibrations." All a bit woo-woo for this cataloguer, but better to see one of these fellows upon turning a corner than any of the myriad abject horrors that litter this volume, so consider yourself fortunate.',
        resistances: "",
        abilities: "",
    },
    {
        id: "lostpunk",
        frequency: "legendary",
        num: "1",
        name: "Lost Punk",
        phylum: "Humanoid",
        size: "medium",
        description:
            'Yes, they\'re technically "dwellers," since they indeed dwell in many a dungeon, but should you come across a Lost Punk you may safely sheathe your sword. They are generally an amenable lot, though they have a remarkably poor sense of direction; most are simply looking for a safe route out of the dungeon, and perhaps a light for their handrolled pipeweed.',
        resistances: "",
        abilities: "",
    },
    {
        id: "manticore",
        frequency: "legendary",
        num: "1",
        name: "Manticore",
        phylum: "Mythic",
        size: "large",
        description:
            "I am ordinarily able to keep a straight face whilst penning these entries, adventurer, but I cannot help but chortle when I merely envisage a manticore. The head of a man on the body of a lion!! With horns for some reason! It's as though someone was making a bunch of GOOD chimeras and needed to use up the leftover parts. Of course it's easy for me to laugh, safe in my spire - but if you do come across a manticore out in the wilds, it will almost surely kill you - if not with its terrible jaws, then with its poisoned tail. But gods, if you are anything like me, you will perish with a joyous smile upon your lips. Just look at it!! It is pathetic! O, it does fill my heart with mirth.",
        resistances: "resistant to fire, arcane",
        abilities: "ranged poison",
    },
    {
        id: "mirthcreant",
        frequency: "uncommon",
        num: "1-3",
        name: "Mirthcreant",
        size: "small",
        phylum: "Fey",
        description:
            "I love a good chuckle as much as the next wizened old alchemist, but the reviews are in and the mirthcreant gets two knobby, arthritic thumbs way down. They sure appear to be having a grand time, as they reflect your attacks back at you, use their arcane nonsense to control your every movement, and bounce giddily around you while peppering you with bolts of colorful magic. But I've always hated audience participation, which is why I try to dispatch these grinning imbeciles quickly and without a shred of mercy. There is a special place in the nine hells for cheaters and comedians, and these impish wretches are both.",
        resistances: "resistant to arcane",
        abilities: "steals food, ranged magic",
    },
    {
        id: "nightfather",
        frequency: "legendary",
        num: "1",
        name: "Night Father",
        phylum: "Undead",
        size: "medium",
        description:
            "Mistake not the name Night Father for the bringer of gifts to children upon the Midwinter's Eve. That is Father Night. Nor mistake him for the benevolent overseer of chivalrous deeds - that's the Knight Father. Beware, too of assuming this is the magical talisman capable of restoring your vigor after days without sleep. That is of course the Night Feather. Anyway, THIS Dweller can rearrange your bones from the inside, with magic.",
        resistances: "resistant to blade, necrotic",
        abilities: "drains brawn",
    },
    {
        id: "paralisk",
        frequency: "rare",
        num: "1-3",
        name: "Paralisk",
        phylum: "Demon",
        size: "medium",
        description:
            'They say the gates of Kha\'Ghol are guarded by seven paralisks. Seven seems like sort of overkill if you ask me, I\'ve seen ONE of these literally melt a score of knights inside their armor. I\'m laughing right now because my notes on the paralisk say "inflicts burning." My gods, that is indeed rich. "Inflicts burning!" You think? Oh, my sides do ache!!',
        resistances: "immune to fire, vulnerable to cold",
        abilities: "inflicts burning",
    },
    {
        id: "quex",
        frequency: "epic",
        num: "1",
        name: "Quex",
        phylum: "Mythic",
        size: "medium",
        description:
            "If, like me, you are primarily a ranged fighter - a wizard, shaman, archer, crossbowtrix, javeleindon, catapulteur, or perhaps an exceptionally skilled rockthrowicus, you surely know the many advantages of keeping your distance during a fight. So it should come as no surprise to you that some Dwellers have taken the same lesson to heart. The quex is an expert at long-distance battle, hovering in the air by ethereal wingbeats and sending fireballs and focused jets of flame at you with stunning accuracy. As peevesome as this strategy may be, let's be honest, adventurers - the proverbial patten has been on the other foot for quite some time.",
        resistances: "resistant to fire, divine",
        abilities: "ranged fire attacks",
    },
    {
        id: "shadowelf",
        frequency: "rare",
        num: "1-4",
        name: "Shadow Elf",
        phylum: "Fey",
        size: "medium",
        description:
            "Normally elves are great! These ones not so much. Poisoned blades, poisoned arrows. They cast apparitions of themselves to obscure their location and kill with neither feeling nor mercy. I'm tempted to say they're hardly elves at all - but they are insufferably pretentious, so at least there's one common thread.",
        resistances: "resistant to necrotic",
        abilities: "ranged necrotic attacks, inflicts poison",
    },
    {
        id: "skell",
        frequency: "uncommon",
        num: "1-3",
        name: "Skell",
        phylum: "Undead",
        size: "medium",
        description:
            "What kind of simpleton looks up a skell in a Dweller's compendium? It's like a chef looking up \"salt.\" Are you honestly telling me you've never seen one of these? This is tutorial-level adventuring right here. Ask literally anyone. Go look up \"sword\" while you're at it, you cretin!",
        resistances: "resistant to blade, vulnerable to bludgeon",
        abilities: "",
    },
    {
        id: "slime",
        frequency: "uncommon",
        num: "1",
        name: "Slime",
        phylum: "Ooze",
        size: "large",
        description:
            "Slime is truly nasty stuff. At least the pudding brothers only pretend to be puddles while they wait for you to get close enough. Slime just sits there, putrid, sticky, noxious - emitting its foul-smelling toxic gases that slowly poison and strangle any man, beast or weed that gets close enough. And heed this, adventurer: you've come so far. You've learned to fight, you've armed yourself, you've announced to your friends and family that you are coming all the way out here to win treasure and acoomplish noble deeds. Don't let THIS be the thing that kills you. Be better.",
        resistances: "resistant to bludgeon, vulnerable to electric",
        abilities: "poison aura, inflicts held",
    },
    {
        id: "stachelig",
        frequency: "epic",
        num: "1",
        name: "Stachelig",
        phylum: "Deep One",
        size: "large",
        description:
            "The key to preparing the mighty Stachelig is to drop it straight into an enormous cauldron of boiling water. That way the meat stays sweet and tender and there's no chance of any sort of food poisoning, which - let me tell you - you DO NOT WANT. Give it 5-10 minutes, crack it open, dip into some drawn butter, maybe a squeeze of Ghornian citrus if you can find it - you've never had better, I promise you. Oh, I'm sorry, you want advice on FIGHTING it? Oh dear. Get ready to be killed is my advice.",
        resistances: "resistant to arcane",
        abilities: "high block",
    },
    {
        id: "toothtube",
        frequency: "epic",
        num: "1-2",
        name: "Toothtube",
        phylum: "Deep One",
        size: "large",
        description:
            "If you're familiar with the popular \"Bidrick's Gruesome Tales for Nervous Children,\" you're probably heard that it takes 500 years to be digested inside of a toothtube. I have never heard a more ridiculous myth in my life! Fear not, for the toothtube's digestive tract is in fact remarkably efficient. Your standard beast of burden is usually in and out in a matter of weeks. I believe the confusion is related to the fact that the toxins within the myriad teeth of the toothtube have the effect of heightening the senses, so that being digested feels like an unbearable, unfathomable eternity. Simple as that. 500 years!! Can you imagine anything more ludicrous? Bidrick is a total hack, by the way.",
        resistances: "resistant to electric, vulnerable to pierce",
        abilities: "powerful bite",
    },
    {
        id: "traveler",
        frequency: "epic",
        num: "1-3",
        name: "Traveler",
        phylum: "Deep One",
        size: "medium",
        description:
            "No one knows whence the travelers have come or toward what they are bound. Their name of course derives from their constant movement, as though making some long journey towards a far distant resting place. And also just their general vibe, you know? Stare not into the bottomless pools of their eyes or you shall fall into a deep sleep, which will surely prove to be your last!",
        resistances: "resistant to cold, vulnerable to electric",
        abilities: "inflicts sleep",
    },
    {
        id: "troll",
        frequency: "epic",
        num: "1-3",
        name: "Troll",
        phylum: "Mythic",
        size: "large",
        description:
            "The assumption that you can avoid trolls simply by avoiding bridges is foolish and, if I may say, a bit culturally insensitive. Trolls thrive in many environments and indeed facets of our society. They are acutely intelligent, wield powerful magic and create some lovely music, if you can get past all the guttural cursing. If you must fight one, beware their disproportionate strength. O, and while there are in fact many trolls who make their homes under a bridge here or there, don't believe any that claim to be \"guarding\" the bridge. It's almost always just good old-fashioned extortion.",
        resistances: "vulnerable to fire",
        abilities: "regenerates",
    },
    {
        id: "vodyanoi",
        frequency: "rare",
        num: "1-3",
        name: "Vodyanoi",
        phylum: "Deep One",
        size: "medium",
        description: "You know who VODYANNOYS ME are these slimy guys. NEXT!",
        resistances: "Electric",
        abilities: "ranged electric attack",
    },
    {
        id: "wererat",
        frequency: "uncommon",
        num: "1-2",
        name: "Were Rat",
        phylum: "Beast",
        size: "medium",
        description:
            "Giant rats that walk upright? Terrific. These abominations are actually former adventurers like yourself, who have succumbed to a terrible disease spread amongst the giant vermin overrunning the ports and villages in these lands. A singe bite from one of them will set the process in motion, so until you are cured, you may find yourself ravenous, twitchy, and sprouting hair in unexpected places. It's like puberty, except you become a literal rat at the end.",
        resistances: "vulnerable to blade",
        abilities: "summons rats",
    },
    {
        id: "wisp",
        frequency: "epic",
        num: "1-5",
        name: "Wisp",
        phylum: "Fey",
        size: "medium",
        description:
            "How do you kill something as ephemeral as a wisp? It cannot be stabbed, it cannot be bludgeoned. It is barely visible by day or night, and often confused for a trace of fog or a beam of moonlight! It's a good thing you wield magic, adventurer. At least, I hope you do. You're not one of those longsword-waving numbskulls who thinks a shield and blade will solve every quandary, are you? Good. I thought not.",
        resistances: "immune to blade, pierce, bludgeon",
        abilities: "inflicts hunger",
    },
    {
        id: "wyrdencat",
        frequency: "uncommon",
        num: "1-2",
        name: "Wyrden Cat",
        phylum: "Fey",
        size: "medium",
        description:
            "I'm one of those wizards who likes to keep a healthy distance from his quarry. These robes are imbued with powerful magic, but impregnable they are NOT. I can't even keep a stiff breeze out, let alone the glimmering knife claws of beasts like the wyrden cat. It's nothing BUT claws, that thing. If you do make the mistake of getting too close, just remember - the wyrden cat lives by the pierce, but it dies by the pierce as well.",
        resistances: "vulnerable to necrotic",
        abilities: "multiple attacks per turn",
    },
    {
        id: "zombie",
        frequency: "uncommon",
        num: "1-8",
        name: "Zombie",
        phylum: "Undead",
        size: "medium",
        description:
            "Yes, zombies are terrible, but at least they smell absolutely abhorrent. Oh, and they make awful sounds while they try to devour you. And of course, they often travel in enormous unthinking herds, AND will sometimes explode if you do not dismember them quickly enough. O! And let us not forget that even if you survive with only a scratch you may soon BECOME ONE YOURSELF! Gods. I do despise zombies. Not because I fear them, but because even writing about them is EXHAUSTING. ",
        resistances: "immune to necrotic, vulnerable to divine",
        abilities: "",
    },
];
